import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import WorkflowsTable from './WorkflowsTable';
import WorkflowEditor from './WorkflowEditor';
import { Workflow } from '@/types/agents';

const Workflows: React.FC = () => {
    const [editingWorkflow, setEditingWorkflow] = useState<Workflow | null>(null);
    const [isCreating, setIsCreating] = useState(false);

    const handleCreateWorkflow = () => {
        setIsCreating(true);
        setEditingWorkflow(null);
    };

    const handleEditWorkflow = (workflow: Workflow) => {
        setEditingWorkflow(workflow);
        setIsCreating(false);
    };

    const handleCancel = () => {
        setEditingWorkflow(null);
        setIsCreating(false);
    };

    // If editing or creating, show the editor
    if (editingWorkflow || isCreating) {
        return (
            <WorkflowEditor
                workflow={editingWorkflow || undefined}
                onSave={(workflow) => {
                    // Handle save - replace with actual API call
                    console.log('Saving workflow:', workflow);
                    handleCancel();
                }}
                onCancel={handleCancel}
            />
        );
    }

    return (
        <div className="w-full">
            {/* Header with title and button to add */}
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-semibold text-foreground">
                    Workflows
                </h2>

                <button
                    onClick={handleCreateWorkflow}
                    className="px-4 py-2 rounded-md transition-colors flex items-center bg-primary text-primary-foreground hover:opacity-90"
                >
                    <Plus size={16} className="mr-2" />
                    Create Workflow
                </button>
            </div>

            {/* Table of workflows */}
            <WorkflowsTable onEdit={handleEditWorkflow} />
        </div>
    );
};

export default Workflows;

